import AssignmentIcon from '@mui/icons-material/Assignment';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import VideoCallIcon from '@mui/icons-material/VideoCall';

import i18n from 'FRONTEND/utils/i18n';

export const getTypeStepSupport = () => {
  return {
    title: i18n._('Which type should you choose?'),
    text: i18n._('The type of appointment defines the kind of participants that you will be able to invite and how the data gathered during the appointment will be processed.'),
    paragraphList: [
      {
        title: i18n._('Video consultation'),
        text: i18n._('Medical consultation between the patient, possibly assisted by a health professional, and a practitioner.'),
        icon: VideoCallIcon,
      },
      {
        title: i18n._('Tele-expertise / Tele-staff / Multidisciplinary team meeting'),
        text: i18n._('Professional-to-professional act, patient not present.'),
        icon: RecentActorsIcon,
      },
      {
        title: i18n._('Other (in-person, etc.)'),
        text: i18n._('Non-telemedicine appointments (in-person consultation, home visit, etc.)'),
        icon: AssignmentIcon,
      },
    ],
  };
};
